/* ============================================================
   custom-header.js — Voss Events three-row header
   ============================================================ */

(function () {
  'use strict';

  var isMobile = function () { return window.innerWidth <= 768; };

  // ── Mobile swipe nav ───────────────────────────────────────
  var navbar       = document.querySelector('.ch-navbar');
  var navList      = document.querySelector('.ch-nav');
  var drawer       = document.getElementById('ch-mobile-subnav-drawer');
  var drawerList   = document.getElementById('ch-mobile-subnav-drawer__list');
  var activeItem   = null;

  // Nudge animation on first load (mobile only)
  function tryNudge() {
    if (!isMobile() || !navList) return;
    navList.classList.add('ch-nav--nudge');
    navList.addEventListener('animationend', function () {
      navList.classList.remove('ch-nav--nudge');
    }, { once: true });
  }

  // Open subnav drawer with links from a nav item
  function openDrawer(item) {
    if (!drawer || !drawerList) return;

    // Collect sublinks from the mega menu in this item
    var sublinks = item.querySelectorAll('.ch-mega a');
    if (sublinks.length === 0) return;

    // Build list items
    drawerList.innerHTML = '';
    sublinks.forEach(function (link) {
      var li = document.createElement('li');
      var a  = document.createElement('a');
      a.href        = link.href;
      a.textContent = link.textContent.trim();
      li.appendChild(a);
      drawerList.appendChild(li);
    });

    // Mark item active
    if (activeItem) activeItem.classList.remove('ch-nav__item--mobile-open');
    activeItem = item;
    item.classList.add('ch-nav__item--mobile-open');

    drawer.classList.add('ch-mobile-subnav-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('ch-mobile-subnav-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    if (activeItem) {
      activeItem.classList.remove('ch-nav__item--mobile-open');
      activeItem = null;
    }
  }

  // Tap handler on nav items
  document.querySelectorAll('.ch-nav__item').forEach(function (item) {
    item.addEventListener('click', function (e) {
      if (!isMobile()) return;

      var hasChildren = item.querySelector('.ch-mega') !== null;

      if (!hasChildren) {
        // Direct link — let it navigate
        return;
      }

      e.preventDefault();

      // Toggle: if already open, close it
      if (item === activeItem) {
        closeDrawer();
        return;
      }

      openDrawer(item);
    });
  });

  // Close drawer when tapping outside
  document.addEventListener('click', function (e) {
    if (!isMobile()) return;
    if (!navbar) return;
    if (!drawer || !drawer.classList.contains('ch-mobile-subnav-drawer--open')) return;
    if (!navbar.contains(e.target) && !drawer.contains(e.target)) {
      closeDrawer();
    }
  });

  // Re-run nudge check on resize
  window.addEventListener('resize', function () {
    if (isMobile()) tryNudge();
    else closeDrawer();
  });

  // Run nudge on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryNudge);
  } else {
    tryNudge();
  }

  // ── Desktop: close mega on Escape ─────────────────────────
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // ── Cart count ────────────────────────────────────────────
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var count = cart.item_count || 0;
      document.querySelectorAll('.ch-topbar__cart-count').forEach(function (badge) {
        badge.textContent = count > 99 ? '99+' : count;
        badge.dataset.count = count;
      });
    })
    .catch(function () {});

  document.addEventListener('cart:updated', function (e) {
    var count = e.detail && e.detail.itemCount != null ? e.detail.itemCount : null;
    if (count === null) return;
    document.querySelectorAll('.ch-topbar__cart-count').forEach(function (badge) {
      badge.textContent = count > 99 ? '99+' : count;
      badge.dataset.count = count;
    });
  });

})();